// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout'
import { roterPre } from '@/settings'
const orderRouter =
  {
    path: `${roterPre}/appraisal`,
    name: 'appraisal',
    meta: {
      icon: 'dashboard',
      title: '美鉴'
    },
    alwaysShow: true,
    component: Layout,
    redirect: `${roterPre}/appraisal`,
    children: [
      {
        path: 'person',
        name: 'appraisalPerson',
        meta: {
          title: '鉴定师管理',
          noCache: true
        },
        component: () => import('@/views/appraisal/person/index')
      }
      ,{
        path: 'person/add/:id?/:edit?',
        component: () => import('@/views/appraisal/person/info'),
        name: 'addPerson',
        meta: { title: '鉴定师添加', noCache: true, activeMenu: `${roterPre}/appraisal/person` },
        hidden: true
      },
      {
        path: 'config',
        name: 'appraisalConfig',
        meta: {
          title: '鉴定配置',
          noCache: true
        },
        component: () => import('@/views/appraisal/config/index')
      },
      {
        path: 'cate',
        name: 'appraisalCate',
        meta: {
          title: '鉴定品类',
          noCache: true
        },
        component: () => import('@/views/appraisal/cate/index')
      },
      {
        path: 'cate/add/:id?/:edit?',
        component: () => import('@/views/appraisal/cate/info'),
        name: 'addCate',
        meta: { title: '品类添加', noCache: true, activeMenu: `${roterPre}/appraisal/cate` },
        hidden: true
      },
      {
        path: 'brand',
        name: 'appraisalBrand',
        meta: {
          title: '鉴定品牌',
          noCache: true
        },
        component: () => import('@/views/appraisal/brand/index')
      },
      {
        path: 'brand/add/:id?/:edit?',
        component: () => import('@/views/appraisal/brand/info'),
        name: 'addCate',
        meta: { title: '品牌添加', noCache: true, activeMenu: `${roterPre}/appraisal/brand` },
        hidden: true
      },
      {
        path: 'entity/order',
        name: 'appraisalEntityOrder',
        meta: {
          title: '实物鉴定订单',
          noCache: true
        },
        component: () => import('@/views/appraisal/entityOrder/index')
      },
      {
        path: 'online/order',
        name: 'appraisalOnlineOrder',
        meta: {
          title: '在线鉴定订单',
          noCache: true
        },
        component: () => import('@/views/appraisal/onlineOrder/index')
      },
      {
        path: 'category',
        name: 'appraisalCategory',
        meta: {
          title: '分类管理',
          noCache: true
        },
        component: () => import('@/views/appraisal/category/index')
      },{
        path: 'category/add/:id?/:edit?',
        component: () => import('@/views/appraisal/category/info'),
        name: 'addCate',
        meta: { title: '分类添加', noCache: true, activeMenu: `${roterPre}/appraisal/category` },
        hidden: true
      },

    ]
  }

export default orderRouter
